import MercadoActivityIcon from '@/components/home/icons/mercado-activity-icon';
import useFantasySelected from '@/DesignSystem/hooks/useFantasySelected';
import { FANTASY } from '@/helpers/biwenger-helper';
import { toPriceInEuros } from '@/helpers/prices-helper';
import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const LineupSummary = ({ players, isTitulares = true }) => {
    const { fantasy } = useFantasySelected();

    const promedios = useMemo(() => {
        if (!players?.length) {
            return {
                valorPromedio: 0,
                subidaPromedio: 0,
            };
        }

        let titulares = isTitulares
            ? players.filter((player) => player.grid > 0)
            : players.filter((player) => !player.grid || player.grid < 10 || player.grid > 60);
        let totalValor = 0;
        let totalSubida = 0;

        if (fantasy === FANTASY.FANTASY_MARCA) {
            titulares = titulares?.filter((player) => player.fantasyMarcaMarketValue > 0);
            totalValor = titulares.reduce(
                (acc, player) => acc + Number(player.fantasyMarcaMarketValue ?? 0),
                0
            );
            totalSubida = titulares.reduce((acc, player) => acc + Number(player.fantasyMarcaSubida ?? 0), 0);
        } else if (fantasy === FANTASY.MISTER_FANTASY) {
            titulares = titulares?.filter((player) => player.misterFantasyMarketValue > 0);
            totalValor = titulares.reduce(
                (acc, player) => acc + Number(player.misterFantasyMarketValue ?? 0),
                0
            );
            totalSubida = titulares.reduce((acc, player) => acc + Number(player.misterFantasySubida ?? 0), 0);
        } else if (fantasy === FANTASY.BIWENGER) {
            titulares = titulares?.filter((player) => player.biwengerMarketValue > 0);
            totalValor = titulares.reduce((acc, player) => acc + Number(player.biwengerMarketValue ?? 0), 0);
            totalSubida = titulares.reduce((acc, player) => acc + Number(player.biwengerSubida ?? 0), 0);
        } else if (fantasy === FANTASY.FANTASY) {
            titulares = titulares?.filter((player) => player.laLigaFantasyMarketValue > 0);
            totalValor = titulares.reduce(
                (acc, player) => acc + Number(player.laLigaFantasyMarketValue ?? 0),
                0
            );
            totalSubida = titulares.reduce((acc, player) => acc + Number(player.laLigaFantasySubida ?? 0), 0);
        }

        return {
            valorPromedio: (totalValor / titulares.length).toFixed(0),
            subidaPromedio: (totalSubida / titulares.length).toFixed(0),
        };
    }, [players, fantasy]);

    const Icon =
        promedios.subidaPromedio > 0 ? (
            <TrendingUp sx={{ color: 'success.main', fontSize: 10 }} />
        ) : (
            <TrendingDown sx={{ color: 'error.main', fontSize: 10 }} />
        );

    if (fantasy === FANTASY.ANALITICA) {
        return null;
    }

    if (!promedios.valorPromedio || !promedios.subidaPromedio) {
        return null;
    }

    return (
        <Box>
            <Typography fontSize={14} color={'#ccc'} mb={0.5}>
                {isTitulares ? 'Promedio de los titulares' : 'Promedio de los suplentes'}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 0.5,
                    border: '1px solid',
                    borderColor: 'border.main',
                    p: 1,
                    borderRadius: 1,
                    height: '30px',
                    mb: 0.5,
                }}
            >
                <Box display={'flex'} alignItems={'center'} gap={1}>
                    <MercadoActivityIcon width={16} height={16} />
                    <Typography variant="body1" color={'#ccc'} fontSize={12}>
                        {toPriceInEuros(promedios.valorPromedio)}
                    </Typography>
                </Box>
                <Box display={'flex'} alignItems={'center'} gap={0.5}>
                    <Box
                        sx={{
                            backgroundColor: 'background.card',
                            borderRadius: '50%',
                            width: 16,
                            height: 16,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        {Icon}
                    </Box>
                    <Typography
                        component={'span'}
                        color={promedios.subidaPromedio > 0 ? 'success.main' : 'error.main'}
                        fontSize={12}
                    >
                        {toPriceInEuros(promedios.subidaPromedio)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default LineupSummary;
